import { isMobile } from "./utils";
const matrikaReachGoals = (counterId, goals) => {
    goals && goals.forEach(goal => {
        document.querySelectorAll(goal.target).forEach(elt => {
            elt.addEventListener(goal.goalEvent, () => {
                console.log(isMobile());
                if (goal.checkMobile) {
                    if (isMobile()) {
                        window.ym(counterId, 'reachGoal', goal.goalId);
                        // console.log(goal.goalEvent, goal.goalId, goal.target, 'mobile');
                    }
                }
                else {
                    window.ym(counterId, 'reachGoal', goal.goalId);
                    // console.log(goal.goalEvent, goal.goalId, goal.target, 'desctop');
                }
            });
        });
    });
};
export default matrikaReachGoals;
